import { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { ButtonComponent } from '../../components/Button'
import { CategoryFormComponent } from '../../components/CategoryForm'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'
import { SpinnerComponent } from '../../components/Spinner'

import { useControlSearchCategories } from '../../hooks/useControlSearchCategories'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

const EditCategoryPage = () => {
    const { id } = useParams()

    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false,
        category: null
    })

    const {_state: _errors} = useSimpleState({})

    const {_view: _viewMain} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control} = useControlSearchCategories()

    const fetch = () => {
        _control.fetchGetCategory(id).then((res) => {
            if (res.status === 200) {
                _state.set('category', res.body)
            } else {
                navigate('/categories')
            }
        }).finally(() => {
            _viewMain.set('main')
        })
    }

    useEffect(() => {
        fetch()
    }, [])

    const handleSubmit = (body) => {
        _state.set('fetching', true)

        _control.fetchEdit(body).then(res => {
            if (res.status === 200) {
                navigate('/categories')
            } else {
                _errors.set(res.errors?.errors || {})
            }
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    const handleDelete = () => {
        _state.set('fetching', true)

        _control.fetchDelete(_state.get('category')).then(() => {
            navigate('/categories')
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    function renderLoading() {
        return (
            <div>
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        return (
            <div>
                <LayoutPage config={{ id: 'ManageDeals' }}>
                    <div className="manageDeals-header">
                        <PageTitleComponent value="Edit Category" />
                        <ButtonComponent config={{ palette: 'gray' }} events={{ handleClick: handleDelete }}>
                            Delete
                        </ButtonComponent>
                    </div>

                    <div className={_state.get('fetching') ? 'disabled' : ''}>
                        <CategoryFormComponent value={_state.get('category')} config={{
                            errors: _errors.get(),
                            actionType: 'edit'
                        }} events={{
                            handleSubmit: handleSubmit
                        }} />
                    </div>
                </LayoutPage>
            </div>
        )
    }

    return _viewMain.get()
}

export { EditCategoryPage }
